import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteDeviceSignalDocument } from './delete.generated';

export const useDeleteDeviceSignal = (
  options: ApiOptions<typeof DeleteDeviceSignalDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(DeleteDeviceSignalDocument, {
    ...useNotifications(DeleteDeviceSignalDocument, {
      failure: t('api.common.error_generic'),
      success: (data) => {
        const count = data.deleteDeviceSignal?.deletedIds.length ?? 0;
        return t('api.device_signals.delete_success_plural', { count });
      },
    }),
    update(cache, { data }) {
      if (!data?.deleteDeviceSignal?.deletedIds.length) return;
      data.deleteDeviceSignal.deletedIds.forEach((id) => cache.evict({ id: `DeviceSignal:${id}` }));
    },
    ...options,
  });
};
